const setupHappinessButtons = () => {
  $(function () {
    const happinessHiddenInput = $('#id_happiness_index');
    const submitBtn = $('#form-submit');
    const happinessIcons = {
      options: [1, 2, 3],
      get: id => ({ id, button: $(`#happiness-icon-${id}`) }),
      all() {
        return this.options.map(this.get);
      },
    };

    const init = () => {
      const lastSelectedOption = +happinessHiddenInput.val();

      if (lastSelectedOption) {
        setActiveHappinessIcon(happinessIcons.get(lastSelectedOption));
        enableSubmitButton();
      }
    };

    const setupEventHandlers = () => {
      happinessIcons.all()
        .forEach((happinessIcon) => {
          happinessIcon.button.on('click', () => {
            setHiddenInputValue(happinessIcon.id);
            setActiveHappinessIcon(happinessIcon);
            enableSubmitButton();
          });
        });
    };

    const setHiddenInputValue = optionID => happinessHiddenInput.val(optionID);

    const setActiveHappinessIcon = (clickedHappinessIcon) => {
      enableButton(clickedHappinessIcon.button);

      happinessIcons.all()
        .filter(happinessIcon => happinessIcon.id !== clickedHappinessIcon.id)
        .forEach(otherHappinessIcon => disableButton(otherHappinessIcon.button));
    };

    const enableButton = (button) => {
      button.addClass('active');
      button.children('.icon').removeClass('outline');
    };

    const disableButton = (button) => {
      button.removeClass('active');
      button.children('.icon').addClass('outline');
    };

    const enableSubmitButton = () => {
      submitBtn.removeClass('disabled');
    };

    init();
    setupEventHandlers();

  });
};

const registerReportUpdateForm = () => {
  setupHappinessButtons();
};

window.registerReportUpdateForm = registerReportUpdateForm;
